export default {
  // strict: true,
  state: {
    seatsInfo: {},
    CreateOrderInfo: {},
    MenuArr: [],
    totalPrice: 0,
    orderNum: null,
    from: null,
    orderEdit: {},
    orderInfo: {}
  },
  getters: {
    getMenuArr: state => {
      return state.MenuArr;
    },
    getTotalPrice: state => {

      state.totalPrice = 0;
      state.MenuArr.forEach(ele => {
        if (ele.itemClasslist.length > 0) {
          let SideDishPrice = 0;
          ele.itemClasslist.forEach(element => {
            if (element.price) {
              SideDishPrice += Number.parseFloat(element.price);
            }
          });
          state.totalPrice +=
            Number.parseFloat(SideDishPrice + ele.pluPrice) * ele.num;
        } else {
          state.totalPrice += Number.parseFloat(ele.pluPrice) * ele.num;
        }
      });
      state.totalPrice = state.totalPrice.toFixed(2);
      return state.totalPrice;
    },
    getTotalNum: state => {
      let total = 0;
      state.MenuArr.forEach(ele => {
        total += ele.num;
      });
      return total;
    }
  },
  mutations: {
    //桌号--餐厅信息
    submitSeatsInfo: (state, val) => {
      state.seatsInfo = val;
      // console.log("state.seatsInfo:", state.seatsInfo);
    },
    submitCreateOrderInfo: (state, val) => {
      state.CreateOrderInfo = val;
      // console.log("state.CreateOrderInfo:", state.CreateOrderInfo);
    },
    submitOrderInfo: (state, val) => {
      state.orderInfo = val;
      state.seatsInfo.code = val.tableNo;
      state.seatsInfo.pccode = val.pccode;
    },
    submitCart: (state, val) => {
      state.MenuArr = val;
    },
    submitTotalPrice: (state, val) => {
      state.totalPrice = val;
    },
    changeMenu: (state, val) => {
      if (val.item.num == 0) {
        state.MenuArr.splice(val.index, 1);
      } else {
        if (val.item.itemClasslist.length == 0) {
          state.MenuArr[val.index] = val.item;
        } else {
          let ishas = false;
          state.MenuArr.forEach((ele, index) => {
            if (
              index != val.index &&
              ele.pluCode == val.item.pluCode &&
              _.isEqual(ele.itemClasslist, val.item.itemClasslist)
            ) {
              ele.num += val.item.num;
              ishas = true;
            }
          });
          if (ishas) {
            state.MenuArr.splice(val.index, 1);
          } else {
            state.MenuArr[val.index] = val.item;
          }
        }
      }

    },
    submitOrderNum(state, val) {
      state.orderNum = val.orderNum;
      state.from = val.from;
    },
    addMenu: (state, val) => {
      let isIn = false;
      state.MenuArr.forEach((element, index) => {
        if (
          element.pluCode == val.pluCode &&
          _.isEqual(element.itemClasslist, val.itemClasslist)
        ) {
          if (val.itemClasslist.length > 0) {
            element.num += val.num;
          } else {
            element.num = val.num;
          }

          isIn = true;
        }
      });
      // console.log("state.MenuArr:", state.MenuArr);
      // console.log("selectedIndex", selectedIndex);
      if (!isIn) {
        state.MenuArr.push(val);
      }
      state.MenuArr = state.MenuArr.filter(data => {
        return data.num > 0;
      });
      //console.log("state.MenuArr:", state.MenuArr);
    },
    cutMenu: (state, val) => {
      let selectedIndex = null;
      let num = 100;
      state.MenuArr.forEach((element, index) => {
        if (element.pluCode == val.pluCode) {
          selectedIndex = index;
          num = val.num;
        }
      });
      if (num > 0) {
        state.MenuArr[selectedIndex] = _.cloneDeep(val);
      } else {
        state.MenuArr.splice(selectedIndex, 1);
      }
    },
    submitOrderEdit: (state, val) => {
      //console.log("state.orderEdit:", val);
      state.orderEdit = val;
      // console.log("state.orderEdit:", state.orderEdit);
    },
    reset: state => {
      state.seatsInfo = {};
      state.CreateOrderInfo = {};
      state.MenuArr = [];
      state.totalPrice = 0;
      state.orderNum = null;
      state.from = null;
      state.orderEdit = {};
    },
    clearCart: state => {
      state.MenuArr = [];
      state.totalPrice = 0;
    },
    clearOrderNum: state => {
      state.orderNum = null;
      state.from = null;
    },
    changePrice: (state, val) => {
      state.MenuArr[val.index] = val.item;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/food.js